"use client";

import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stories = [{
  title: "Il Cannolo Siciliano",
  subtitle: "Il Re della Pasticceria",
  description: "Le origini del cannolo si perdono nella leggenda, tra i fasti della dominazione araba e le celebrazioni del Carnevale. Il segreto risiede nel contrasto perfetto: una cialda ('scorza') fritta, croccante e dorata, che accoglie al momento del servizio una crema di ricotta di pecora setosa, lavorata con zucchero e un pizzico di cannella. Da Dolci Sapori, rispettiamo l'antica ricetta di Sciacca, guarnendo le estremità con granella di pistacchio o scorza d'arancia candita.",
  image: "https://dolcisapori.10web.cloud/wp-content/uploads/2026/03/Cannolo-Siciliano-psticceria-artigianale-Sicilia-Dolci-Sapori-Sciacca-1.webp",
  alt: "Cannolo siciliano artigianale con ricotta fresca e pistacchio",
  ctaText: "Ordina Cannoli su WhatsApp",
  whatsappMessage: "Salve, vorrei ordinare dei cannoli siciliani freschi."
}, {
  title: "Ciminati",
  subtitle: "Il Gusto Quotidiano della Tradizione",
  description: "Dolci semplici e genuini, caratterizzati dalla presenza del sesamo, che dona un profumo intenso e una piacevole croccantezza.\n\n\nPreparati con ingredienti tradizionali e lavorati secondo ricette tramandate, i ciminati rappresentano la pasticceria più autentica, quella di tutti i giorni.\n\n\nPerfetti per accompagnare caffè, tè o momenti di pausa, sono l’espressione più sincera della tradizione siciliana.",
  image: "https://dolcisapori.10web.cloud/wp-content/uploads/2026/03/Ciminati-psticceria-artigianale-Sicilia-Dolci-Sapori-Sciacca.webp?v=voq6zj2h83",
  alt: "Cassata siciliana tradizionale con frutta candita e pasta reale",
  ctaText: "Ordina Ciminati su WhatsApp",
  whatsappMessage: "Salve, vorrei ordinare una cassata siciliana tradizionale."
}];
export default function ISegretiDellaTradizioneCopy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}